import { React, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import config from "../constants/Env";
import { Helmet } from "react-helmet";
import Variables from "../constants/Variables";

function MetaTags({ pageData }) {
  // define state
  let location = useLocation();
  let [canonicalURL, setCanonicalURL] = useState("");
  let [metaData, setMetaData] = useState({});

  useEffect(() => {
    canonicalURL = config.sitePortalBaseUrl + location.pathname;
    setCanonicalURL(canonicalURL);
  }, [location]);

  useEffect(() => {
    setMetaData(pageData);
  }, [pageData]);

  return (
    <Helmet>
      <meta charSet="utf-8" />
      <title>
        {metaData?.meta_title
          ? metaData?.meta_title
          : Variables?.pageData?.meta_title}
      </title>
      <meta
        name="title"
        content={
          metaData?.meta_title
            ? metaData?.meta_title
            : Variables?.pageData?.meta_title
        }
      />
      <meta
        name="description"
        content={
          metaData?.meta_description
            ? metaData?.meta_description
            : Variables?.pageData?.meta_description
        }
      />
      <meta
        name="keywords"
        content={
          metaData?.meta_keywords
            ? metaData?.meta_keywords
            : Variables?.pageData?.meta_keywords
        }
      />
      <link rel="canonical" href={canonicalURL} />
    </Helmet>
  );
}

export default MetaTags;
